export default __webpack_public_path__ + "images/AD.acdf55e.png";